import { ArrowLeft } from '@peacecover/icon';
import { useHandleHistoryBack } from '../../../utils/useHandleHistoryBack';

interface CommonHeaderProps {
  title: string;
  leftContent?: React.ReactNode;
  handleLeftClick?: () => void;
  rightContent?: React.ReactNode;
  handleRightClick?: () => void;
}

const CommonHeader = ({
  title,
  leftContent,
  handleLeftClick,
  rightContent,
  handleRightClick
}: CommonHeaderProps) => {
  const handleHistoryBack = useHandleHistoryBack();
  return (
    <header className="fixed top-0 left-0 right-0 z-10 px-[16px] pt-[calc(12px+env(safe-area-inset-top))] pb-[12px] bg-background-light dark:bg-background-dark">
      <div className="relative flex items-center justify-center w-full">
        <button
          type="button"
          className="absolute left-0 top-1/2 -translate-y-1/2"
          onClick={() => {
            if (handleLeftClick) {
              handleLeftClick();
            } else {
              handleHistoryBack();
            }
          }}
        >
          {leftContent ? leftContent : <ArrowLeft size={24} className="text-text-main-lv1" />}
        </button>
        <h1 className="text-text-main-lv1 text-[17px] font-bold leading-[20px]">{title}</h1>
        {rightContent && (
          <button
            type="button"
            className="absolute right-0 top-1/2 -translate-y-1/2"
            onClick={() => {
              if (handleRightClick) {
                handleRightClick();
              } else {
                handleHistoryBack();
              }
            }}
          >
            {rightContent}
          </button>
        )}
      </div>
    </header>
  );
};

export default CommonHeader;
